import { render, staticRenderFns } from "./VoteGuidePage.vue?vue&type=template&id=35bddc44"
import script from "./VoteGuidePage.vue?vue&type=script&lang=js"
export * from "./VoteGuidePage.vue?vue&type=script&lang=js"
import style0 from "./VoteGuidePage.vue?vue&type=style&index=0&id=35bddc44&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports